// Alvanex — Cart Drawer. Vanilla JS, no dependencies.
// Progressive enhancement: every form here already works as a normal POST to
// /cart/add and /cart (see main-cart.liquid) if this script fails to load or
// a fetch call errors — this only intercepts to avoid a full page reload.

(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.cart-drawer__panel');
  var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';
  var lastFocused = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', parts[0])
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openDrawer(trigger) {
    lastFocused = trigger || document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    setTimeout(function () {
      panel.focus();
    }, 50);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer();
    } else {
      trapFocus(e);
    }
  }

  drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function updateShipping(cart) {
    // Plain, merchant-edited text (Theme Settings) — Shopify has no way to
    // detect shipping discounts in Liquid or the Cart API, so this is never
    // computed, only shown or hidden based on whether the cart has items.
    var wrap = drawer.querySelector('[data-cart-shipping-wrap]');
    if (!wrap) return;
    wrap.hidden = cart.item_count === 0;
  }

  // Cart-level automatic discounts Shopify has already calculated — real data
  // from the Cart API, never invented. Discount codes never appear here;
  // Shopify only resolves those at checkout.
  function renderDiscounts(cart) {
    var wrap = drawer.querySelector('[data-cart-discounts]');
    if (!wrap) return;
    var discounts = cart.cart_level_discount_applications || [];
    if (cart.item_count === 0 || discounts.length === 0) {
      wrap.hidden = true;
      wrap.innerHTML = '';
      return;
    }
    wrap.hidden = false;
    wrap.innerHTML = discounts.map(function (discount) {
      return (
        '<p class="cart-drawer__discount-line">' +
          '<span class="cart-drawer__discount-title">' + discount.title + '</span>' +
          '<span class="cart-drawer__discount-amount">&minus;' + formatMoney(discount.total_allocated_amount) + '</span>' +
        '</p>'
      );
    }).join('');
  }

  function itemHtml(item) {
    var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>'
      : '';
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_200x$1$2') + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
      : '';
    var hasLineDiscount = item.line_level_total_discount > 0 || (item.total_discount || 0) > 0;
    var originalPriceHtml = hasLineDiscount
      ? '<s class="cart-drawer__item-original-price">' + formatMoney(item.original_price || (item.original_line_price / item.quantity)) + '</s>'
      : '';
    var discountAllocations = item.line_level_discount_allocations || item.discounts || [];
    var discountHtml = '';
    if (hasLineDiscount && discountAllocations.length > 0) {
      discountHtml = '<div class="cart-drawer__item-discount">' +
        discountAllocations.map(function (allocation) {
          var title = allocation.discount_application ? allocation.discount_application.title : allocation.title;
          var amount = allocation.amount != null ? allocation.amount : allocation.total_allocated_amount;
          return title + ' &minus;' + formatMoney(amount);
        }).join(', ') +
        '</div>';
    }
    return (
      '<div class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-media" tabindex="-1">' + img + '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>' +
          variantHtml +
          '<div class="cart-drawer__item-price price">' + formatMoney(item.final_price) + originalPriceHtml + '</div>' +
          discountHtml +
          '<div class="cart-drawer__item-controls">' +
            '<div class="cart-drawer__qty">' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">−</button>' +
              '<span class="cart-drawer__qty-value" data-cart-qty-value>' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" data-cart-remove aria-label="Remove ' + (item.title || '').replace(/"/g, '&quot;') + ' from bag">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart(cart) {
    var itemsWrap = drawer.querySelector('[data-cart-items]');
    var emptyWrap = drawer.querySelector('[data-cart-empty]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var subtotal = drawer.querySelector('[data-cart-subtotal]');

    if (cart.item_count === 0) {
      if (itemsWrap) itemsWrap.hidden = true;
      if (footer) footer.hidden = true;
      if (emptyWrap) emptyWrap.hidden = false;
    } else {
      if (itemsWrap) {
        itemsWrap.hidden = false;
        itemsWrap.innerHTML = cart.items.map(itemHtml).join('');
      }
      if (footer) footer.hidden = false;
      if (emptyWrap) emptyWrap.hidden = true;
    }

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    updateShipping(cart);
    renderDiscounts(cart);

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  // Event delegation — items are re-rendered wholesale, so listeners live on the container.
  var itemsContainer = drawer.querySelector('[data-cart-items]');
  if (itemsContainer) {
    itemsContainer.addEventListener('click', function (e) {
      var itemEl = e.target.closest('[data-cart-item]');
      if (!itemEl) return;
      var key = itemEl.getAttribute('data-key');
      var qtyEl = itemEl.querySelector('[data-cart-qty-value]');
      var currentQty = parseInt(qtyEl.textContent, 10) || 1;

      if (e.target.closest('[data-cart-qty-increase]')) {
        changeItem(key, currentQty + 1);
      } else if (e.target.closest('[data-cart-qty-decrease]')) {
        changeItem(key, Math.max(1, currentQty - 1));
      } else if (e.target.closest('[data-cart-remove]')) {
        changeItem(key, 0);
      }
    });
  }

  // Intercept every product-add form on the site (Shopify's {% form 'product' %}
  // always posts to /cart/add), so Add to Bag opens the drawer instead of
  // reloading the page.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form') || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var submitter = e.submitter || form.querySelector('[type="submit"]');
    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
        openDrawer(submitter);
      })
      .catch(function (err) {
        console.error('Add to cart failed:', err && err.message ? err.message : err);
      });
  });

  // Cart icon: open the drawer instead of navigating, when drawer mode is enabled.
  document.querySelectorAll('[data-cart-drawer-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        renderCart(cart);
        openDrawer(trigger);
      });
    });
  });
})();
